import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Checkbox, Header, Icon, Table } from 'semantic-ui-react';

import IntegrationSyncSelect from './IntegrationSyncSelect';
import LegacyTabPermissionGroup from './LegacyTabPermissionGroup';

const RESOURCE_TYPES = [
  {label: 'Accounts', icon: 'user'},
  {label: 'External Tabs', icon: 'external'},
  {label: 'Permission Sets', icon: 'key'},
];

const EditPermissionSet = (props) => {
  // const id = parseInt(props.match.params.id, 10);
  const { name = 'DS Develop' } = props;
  return (
    <React.Fragment>
      <Header as="h2">
        Edit Permission Set
        <Header.Subheader>{name}</Header.Subheader>
      </Header>

      <Header as="h3">Integration Sync</Header>
      <IntegrationSyncSelect />

      <Header as="h3">Resource Types</Header>
      <Table collapsing>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell />
            <Table.HeaderCell><Icon name="eye" /></Table.HeaderCell>
            <Table.HeaderCell><Icon name="plus" /></Table.HeaderCell>
            <Table.HeaderCell><Icon name="pencil" /></Table.HeaderCell>
            <Table.HeaderCell><Icon name="trash" /></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {RESOURCE_TYPES.map((ot) => (
            <Table.Row key={ot.label}>
              <Table.Cell>{ot.label}</Table.Cell>
              <Table.Cell><Icon name={ot.icon} /></Table.Cell>
              <Table.Cell title={`View ${ot.label}`}><Checkbox /></Table.Cell>
              <Table.Cell title={`Edit ${ot.label}`}><Checkbox /></Table.Cell>
              <Table.Cell title={`Update ${ot.label}`}><Checkbox /></Table.Cell>
              <Table.Cell title={`Delete ${ot.label}`}><Checkbox /></Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      <LegacyTabPermissionGroup />

      <Button primary>Save</Button>
      <Button as={Link} to="/o/permission-sets">Cancel</Button>
    </React.Fragment>
  );
};

export default EditPermissionSet;
